const noop = () => 0 as any;

export default noop;
